import { render, staticRenderFns } from "./AppAlerts.vue?vue&type=template&id=8c1c9be8&"
import script from "./AppAlerts.vue?vue&type=script&lang=ts&"
export * from "./AppAlerts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports